import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id',
)({
  beforeLoad: ({ params, location }) => {
    const base = `/supply-chain-mapping/supply-chains/${params.id}`;
    if (location.pathname === base || location.pathname === `${base}/`) {
      throw redirect({
        to: '/supply-chain-mapping/supply-chains/$id/diagram',
        params: { id: params.id },
      });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../../-components/SupplyChainDetailLayout'),
    'SupplyChainDetailLayout',
  ),
});
